class HelpPopup {

    constructor() {

        return {
            restrict: 'AE',
            scope: {
                title: '=',
                message: '='
            },
            template: '<a href="" tabindex="-1" popover-trigger="focus" uib-popover="{{message}}" popover-title="{{title}}" class="help-popup"><i class="fa fa-info-circle"></i></a>',
            link: () => { }
        };

    }

}

angular.module('cpm')
    .directive('helpPopup', [() => {
        'use strict';
        return new HelpPopup();
    }]);
